import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { HisSharedModule } from 'hisng';

import { ConfirmationDialogComponent } from './component/confirmation-dialogs/confirmation-dialog.component';
import { InformationDialogComponent } from './component/confirmation-dialogs/information-dialog.component';

import { CollapsibleBlockViewComponent } from './component/display/collapsible-block-view';


/**
 * SharedModule for common components.
 */
@NgModule( {
    imports: [
        ConfirmDialogModule,
        CommonModule,
        // HIS
        HisSharedModule
    ],

    declarations: [
        ConfirmationDialogComponent,
        InformationDialogComponent,

        CollapsibleBlockViewComponent],

    exports: [
        ConfirmationDialogComponent,
        InformationDialogComponent,

        CollapsibleBlockViewComponent
    ]
    // NO PROVIDERS! Providers need to go into CommonCoreModule
} )
export class CommonSharedModule {
}
